export const chartColKeys = ['extractChart'];
export const chartColTips = {
  extractChart: '智能解析文献，提取文献内图片和表格'
} as const;

export type ChartColKey = keyof typeof chartColTips;

export const LANG_LIST = [{
  label: '中文',
  value: 'zh',
}, {
  label: '英文',
  value: 'en',
}, {
  label: '与文献语言相同',
  value: 'default',
}];

export const DEFAULT_LANG = 'zh';